import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e?.response?.data?.detail) || e?.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background text-foreground">
      <form className="w-full max-w-sm space-y-5" onSubmit={submit} data-testid="forgot-password-form">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">Account recovery</div>
          <h2 className="text-2xl sm:text-3xl tracking-tight font-semibold">Forgot password</h2>
          <p className="text-sm text-zinc-500 mt-2">
            Enter your work email and we&apos;ll send you a secure reset link.
          </p>
        </div>

        {sent ? (
          <div className="text-sm text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-900/40 bg-emerald-50 dark:bg-emerald-950/30 px-3 py-3 rounded-sm" data-testid="forgot-password-sent">
            If an account exists for this email address, a password reset link has been sent.
          </div>
        ) : (
          <>
            {err && (
              <div className="text-sm text-red-600 border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-950/30 px-3 py-2 rounded-sm" data-testid="forgot-password-error">
                {err}
              </div>
            )}
            <div className="space-y-2">
              <Label className="text-[10px] uppercase tracking-[0.2em] font-bold">Work email</Label>
              <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-sm bg-foreground text-background hover:bg-zinc-800 dark:hover:bg-zinc-200" data-testid="forgot-submit-button">
              {busy ? "Sending…" : "Send Reset Link"}
            </Button>
          </>
        )}

        <p className="text-sm text-zinc-500">
          <Link to="/login" className="underline underline-offset-4 text-foreground" data-testid="forgot-back-to-login">
            Back to Login
          </Link>
        </p>
      </form>
    </div>
  );
}
